import './header.scss';
import 'magnific-popup';

export default async () => {
	// Menu
	$( '.header__nav-list > li > .header__mega-menu' ).parent( 'li' ).addClass( 'has-children' );
	$( '.header__nav-list > .has-children > a' ).append().after( '<span class=\'header__mm-arrow js-toggle-arrow\'><i class=\'icon-arrow-down\'></i></span>' );
	$( '.js-toggle-arrow' ).click( function ( e ) {
		e.preventDefault();
		let $this = $( this );

		if ( $this.hasClass( 'is-active' ) ) {
			$this.removeClass( 'is-active' );
			$this.next().slideUp( 350 );
		} else {
			$this.parent().parent().find( '.js-toggle-arrow' ).removeClass( 'is-active' );
			$this.parent().parent().find( '.header__mega-menu' ).slideUp( 350 );
			$this.toggleClass( 'is-active' );
			$this.next().slideToggle( 350 );
		}
	} );

	// Js-toggle-menu
	const toggleMobileButtons = document.querySelectorAll( '.js-toggle-menu' );
	const body = document.querySelector( 'body' );

	toggleMobileButtons.forEach( ( button ) => {
		button.addEventListener( 'click', () => {
			button.classList.toggle( 'is-active' );
			if ( body ) {
				body.classList.toggle( 'is-menu-open' );
			} else {
				// Console.log( 'Body element not found.' );
			}
		} );
	} );

	// Popup-form
	const popupElements = document.querySelectorAll( '.js-popup-form' );

	popupElements.forEach( ( el ) => {
		$( el ).magnificPopup( {
			type: 'inline',
			preloader: false,
			focus: '#name',
		} );
	} );

	const formInputs = document.querySelectorAll( '.js-popup-input' );

	formInputs.forEach( ( item ) => {
		item.addEventListener( 'click', function (  ) {
			item.parentElement.nextElementSibling.click();
		} );
	} );

	// Range
	document.querySelectorAll( '.tenure-slider' ).forEach( ( container ) => {
		const range = container.querySelector( 'input[type="range"]' );
		const tenureMarkers = container.querySelectorAll( '.tenure-markers span' );

		function runRange () {
			const val = range.value;
			const {
				min,
			} = range;
			const {
				max,
			} = range;
			const newValue = ( ( val - min ) * 100 ) / ( max - min );
			const newPosition = 16 - ( newValue * 0.32 );

			range.style.setProperty( '--range-progress', `calc(${newValue}% + (${newPosition}px))` );

			tenureMarkers.forEach( ( marker, i ) => {
				const text = val > 1 ? `${val} days` : `${val} day`;

				if ( marker.textContent === text ) {
					tenureMarkers.forEach( ( item ) => item.classList.remove( 'is-active' ) );
					Array.from( tenureMarkers ).slice( 0, i + 1 ).forEach( ( item ) => item.classList.add( 'is-active' ) );
				}
			} );
		}

		// Initialize and bind events
		if ( range ) {
			runRange();
			range.addEventListener( 'input', runRange );
		}
	} );
};
